// extracted by mini-css-extract-plugin
module.exports = {"Auth":"Auth_Auth__3pVq9","auth":"Auth_auth__3IyoU","Input":"Auth_Input__34hwa"};